import { useContingencyBlinking } from '@hooks/useContingencyBlinking';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { selectTargetFeatures } from '@redux/situation/situation.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

import {
  targetBlinkingLayer,
  targetFlightPlanLinksLayer,
  targetLayer,
  targetLinkLayer,
  targetSpeedVector,
  targetTrajectory,
} from './target.layer';

function TargetLayer() {
  const targetsFeatures = useSelectorWithMapId(selectTargetFeatures);

  useContingencyBlinking();

  if (!isFeatureCollection(targetsFeatures)) return null;

  return (
    <Source id={SourceNameEnum.TARGETS} type="geojson" data={targetsFeatures}>
      <Layer {...targetFlightPlanLinksLayer} />
      <Layer {...targetLinkLayer} />
      <Layer {...targetTrajectory} />
      <Layer {...targetSpeedVector} />
      <Layer {...targetLayer} />
      <Layer {...targetBlinkingLayer} />
    </Source>
  );
}

export default TargetLayer;
